const SERVER_SIDE_LOGOUT_ENV_NAME = "REACT_APP_SERVER_SIDE_LOGOUT_ENABLED";

export const SERVER_SIDE_LOGOUT_FLAG_PLACEHOLDER =
  "${REACT_APP_SERVER_SIDE_LOGOUT_ENABLED}";

const isRuntimeFlagEnabled = (value?: string) =>
  value?.trim().toLowerCase() === "true";

// Keep this as a runtime read so build optimization does not fold the placeholder comparison.
const getRuntimeFlagValue = () => SERVER_SIDE_LOGOUT_FLAG_PLACEHOLDER.slice(0);

/**
 * Resolves the flag from the value nginx-envsubst.sh wrote into the bundle at
 * container start. If the placeholder was never substituted (local dev, tests,
 * or the env var is unset in the pod), falls back to the build-time value.
 */
export const resolveServerSideLogoutFlag = (
  runtimeFlag: string,
  buildTimeFlag: string | undefined,
): boolean =>
  isRuntimeFlagEnabled(
    runtimeFlag.includes(SERVER_SIDE_LOGOUT_ENV_NAME)
      ? buildTimeFlag
      : runtimeFlag,
  );

export const isServerSideLogoutEnabled = (): boolean =>
  resolveServerSideLogoutFlag(
    getRuntimeFlagValue(),
    process.env.REACT_APP_SERVER_SIDE_LOGOUT_ENABLED,
  );
